<app-layout>
  <mat-sidenav-container>
    <mat-sidenav #sidenav role="navigation">
      <app-sidenav-list (sidenavClose)="sidenav.close()"></app-sidenav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <app-header (sidenavToggle)="sidenav.toggle()" *ngIf="displayHeader"></app-header>
      <main>
        <alert></alert>
        <router-outlet (activate)="toggleHeader()"></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <app-spinner></app-spinner>
</app-layout>
